"use client"

import { create } from "zustand"
import type { Room } from "@workspace/livekit/client"
import { VoiceboxProps } from "@/schemas"

interface MeridialState {
  open: boolean
  setOpen: (open: boolean) => void
  props: VoiceboxProps | undefined
  setProps: (
    updater: (prev: VoiceboxProps | undefined) => VoiceboxProps
  ) => void
  room: Room | null
  setRoom: (room: Room | null) => void
}

export const useMeridialStore = create<MeridialState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  props: undefined,
  setProps: (updater) => set((state) => ({ props: updater(state.props) })),
  room: null,
  setRoom: (room) => set({ room }),
}))
